import { Stack } from '@mui/material';
import type { ReactNode } from 'react';
import Barcode from 'react-barcode';
import { graphql, useFragment } from 'react-relay';

import { CopyInput } from '@woovi/ui';

import { useChargePaymentMethod } from '../../../charge/useChargePaymentMethod.tsx';
import type { PaymentActiveBarcode_charge$key } from '../paymentActive/__generated__/PaymentActiveBarcode_charge.graphql.ts';

type PaymentActiveBarcodeProps = {
  charge: PaymentActiveBarcode_charge$key;
  barcodeShow: boolean;
  setBarcodeShow: (value: boolean) => unknown;
  copyBarcodeError: boolean;
};
const PaymentActiveBarcode = (props: PaymentActiveBarcodeProps): ReactNode => {
  const charge = useFragment<PaymentActiveBarcode_charge$key>(
    graphql`
      fragment PaymentActiveBarcode_charge on Charge {
        ...useChargePaymentMethod_charge
      }
    `,
    props.charge,
  );

  const { boleto } = useChargePaymentMethod(charge);

  return (
    <>
      <Stack
        sx={{
          '@media (max-width: 600px)': {
            display: 'none',
          },
        }}
      >
        <Barcode
          value={boleto.boletoBarcode}
          displayValue={false}
          format='ITF'
          width={1}
        />
      </Stack>
      <Stack
        sx={{
          '@media (min-width: 600px)': {
            display: 'none',
          },
        }}
      >
        <CopyInput
          value={boleto.boletoDigitable}
          error={props.copyBarcodeError}
          onError={(error) => props.setBarcodeShow(!error)}
        />
      </Stack>
    </>
  );
};

export default PaymentActiveBarcode;
